/** Contrato API: tipos de agregação numérica (1–7). */
export const NUMERIC_AGGREGATION = {
  Sum: 1,
  Average: 2,
  Min: 3,
  Max: 4,
  Product: 5,
  SubtractOldestMinusRest: 6,
  DivideOldestByProductRest: 7,
} as const;

export type NumericAggregationCode = (typeof NUMERIC_AGGREGATION)[keyof typeof NUMERIC_AGGREGATION];
